module.exports = __webpack_public_path__ + "img/open.2dadd92b.png";